import React, {ReactNode} from "react";
import styled from "@emotion/styled";
import Colors from "../../styles/Colors";
import Section from "../container/Section";

interface Props {
    children: ReactNode,
}

const ThirtyThreePercentCard = (props: Props) => {
    return (
        <Container>
            <Section paddingHorizontal={20}>
                {props.children}
            </Section>
        </Container>
    )
}

export default ThirtyThreePercentCard

const Container = styled.div`
  width: 33.33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${Colors.white};
  
  @media (min-width: 1025px) {
    min-height: 450px;
  }
  
  @media (max-width: 1024px) {
      width: 100%;
      margin-bottom: 70px;
  }
`
